import React, { useEffect, useState } from "react";
import { Row, Col, Button, Card } from "react-bootstrap";
import styles from "./RectangularCard.module.css";
import { useMyContext } from "../../myContext";
import docs from "../../public/assets/Docs.svg";
import canada from "../../public/assets/caflag.svg";
import globe from "../../public/assets/GlobeImage.png";
import germany from "../../public/assets/geflag.svg";
import InfoBox from "../InfoBox/InfoBox";

const RectangularCard = ({
  image,
  heading,
  subHeading = "",
  checkbox = false,
  selectedObject,
  description,
  key,
}) => {
  const { purposeId, setPurposeId, themeColor } = useMyContext();
  const isSelected =
    selectedObject &&
    selectedObject.purposeId &&
    purposeId !== "" &&
    purposeId === selectedObject.purposeId;

  return (
    <Card
      className={
        isSelected
          ? styles.outerCardSelected
          : checkbox
            ? styles.outerCardCheckBox
            : styles.outerCard
      }
      style={isSelected ? { borderColor: themeColor } : {}}
      onClick={() => {
        setPurposeId(selectedObject?.purposeId);
        sessionStorage.setItem("subPurpose", selectedObject?.title);
      }}
    >
      <Row className={styles.firstRow}>
        <Col
          md={1}
          sm={1}
          xs={checkbox === true ? 1 : 2}
          className={!checkbox ? styles.imageCard : styles.imageCheckBox}
        >
          {checkbox === true ? (
            <input
              class="form-check-input"
              className={styles.checkbox}
              type="radio"
              id="flexCheckChecked"
              onChange={() => {
                setPurposeId(selectedObject.purposeId);
                sessionStorage.setItem("subPurpose", selectedObject.title);
              }}
              checked={
                purposeId !== "" && purposeId === selectedObject.purposeId
              }
            />
          ) : (
            <img className={styles.imageDiv} src={image} alt="" />
          )}
        </Col>
        <Col
          md={10}
          sm={10}
          xs={9}
          className={checkbox ? styles.secondcolCheckbox : styles.secondcol}
        >
          <p className={checkbox ? styles.checkboxheading : styles.heading}>
            {heading}
          </p>
          {subHeading !== "" && (
            <p className={styles.subHeading}>{subHeading}</p>
          )}
        </Col>
        {/* {checkbox === true && <Col  md={1} sm={1} xs={2} className={styles.flagDiv}>
        <InfoBox content={""} show={false} image={heading === "GIC" ? canada : heading === "Blocked Account" ? germany : globe} size={30} borderRadius={50} showContent={true}/>
        </Col>} */}
      </Row>
      {isSelected && description !== null ? (
        <>
          <Row className={styles.secondRow}>
            <Col md={1} sm={1} xs={2} className={styles.docsCard}>
              <img
                src={docs}
                alt=""
                style={{ height: "16px", width: "16px" }}
              ></img>
            </Col>
            <Col md={10} sm={10} xs={10} className={styles.docsBox}>
              <p className={styles.docsHeading}>Instructions for Remittance</p>
            </Col>
          </Row>
          <Row className={styles.thirddRow}>
            <Col md={10} sm={10} xs={10} className={styles.docsBox}>
              {description !== null &&
                description["Instructions for Remittance"] &&
                description["Instructions for Remittance"].length !== 0 && (
                  <ul className={styles.docsList}>
                    {description["Instructions for Remittance"].map(
                      (item, index) => (
                        <li key={index} className={styles.docsListItem}>
                          {item}
                        </li>
                      ),
                    )}
                  </ul>
                )}
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
    </Card>
  );
};

export default RectangularCard;
